import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BackButtonComponent } from '../../../components/utility/back-button/back-button.component';
import { BhashiniLanguageTranslationComponent } from '../../../components/utility/bhashini-language-translation/bhashini-language-translation.component';
import { ApiService } from '../../../services/api.service';
import { UtilityService } from '../../../services/utility.service';
import { apiErrorHandler } from '../../../constants/api-error-handler';
import { Subscription } from 'rxjs';
import { routes } from '../../../constants/routes';

@Component({
  selector: 'app-register-step-2',
  standalone: true,
  imports: [BackButtonComponent, BhashiniLanguageTranslationComponent, CommonModule],
  templateUrl: './register-step-2.component.html',
  styleUrl: './register-step-2.component.scss',
})
export class RegisterStep2Component implements OnInit, OnDestroy {
  emailRegistration = {
    icon: 'images/email-icon.svg',
    title: 'Email Registration',
    description: 'Standard Email and OTP registration',
    permissions: [
      'No verification needed',
      'Immediate access as Explorer',
      'Verify later to upgrade your role.',
    ],
    buttonText: 'Continue with Email Registration',
    id: 'emailRegistration',
  };

  meriPehchaanRegistration = {
    icon: 'images/meripehchaan-logo.svg',
    title: 'Meri Pehchaan',
    description: 'Government-verified digital identity',
    isRecommended: true,
    permissions: [
      'Government verified',
      'Suitable for all roles',
      'Trusted identity verification',
    ],
    recommendation:
      'If you own an organization, you can request Organization Admin role',
    buttonText: 'Continue with Meri Pehchaan',
    id: 'meriPehchaanRegistration',
  };

  parichayRegistration = {
    icon: 'images/parichay.png',
    title: 'Parichay',
    description: 'Exclusive for government employees',
    permissions: [
      'Government employee verification',
      'Suitable for all roles',
      'Trusted identity verification',
    ],
    recommendation:
      'Requires existing Mera Parichay account - for government employees only',
    buttonText: 'Continue with Parichay',
    id: 'parichayRegistration',
  };

  janParichayRegistration = {
    icon: 'images/jan-parichay.svg',
    title: 'Jan Parichay',
    description: 'Government-verified digital identity',
    isRecommended: true,
    permissions: [
      'Government verified',
      'Suitable for all roles',
      'Trusted identity verification',
    ],
    recommendation:
      'If you own an organization, you can request Organization Admin role',
    buttonText: 'Continue with Jan Parichay',
    id: 'janParichayRegistration',
  };
  roleQuerryParam: string = '';
  nssoAuthSubs?: Subscription;
  parichayAuthSubs?: Subscription;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private utilService: UtilityService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.roleQuerryParam = params['role'] || '';
    });
  }

  redirectToHome() {
    this.router.navigate(['/']);
  }

  getMeriPehchaanUrl() {
    this.nssoAuthSubs = this.apiService.fetchNssoAuth().subscribe({
      next: (res) => {
        const meriPehchanUrl = res;
        this.utilService.openExternalPage(meriPehchanUrl);
      },
      error: apiErrorHandler.bind(this),
    });
  }

  getParichayUrl() {
    this.parichayAuthSubs = this.apiService.fetchParichayAuth().subscribe({
      next: (res) => {
        const parichayUrl = res;
        this.utilService.openExternalPage(parichayUrl);
      },
      error: apiErrorHandler.bind(this),
    });
  }

  getJanParichayUrl() {
    this.parichayAuthSubs = this.apiService.fetchJanParichayAuth().subscribe({
      next: (res) => {
        const parichayUrl = res;
        this.utilService.openExternalPage(parichayUrl);
      },
      error: apiErrorHandler.bind(this),
    });
  }

  onRegistration(id: string) {
    if (id === 'emailRegistration') {
      this.router.navigate([
        routes.account,
        routes.user,
        routes.userIdentitySetup,
      ]);
    } else if (id === 'meriPehchaanRegistration') {
      this.getMeriPehchaanUrl();
    } else if (id === 'parichayRegistration') {
      this.getParichayUrl();
    } else if (id === 'janParichayRegistration') {
      this.getJanParichayUrl();
    }
  }

  redirectToLogin() {
    this.router.navigate(['/', routes.account, routes.user, routes.login]);
  }

  ngOnDestroy() {
    this.nssoAuthSubs?.unsubscribe();
    this.parichayAuthSubs?.unsubscribe();
  }
}
